import React from 'react'
import Helmet from 'react-helmet'
import SEO from '../components/SEO'


export default function PageTemplate({data}) {
  const { markdownRemark: post } = data;

  let seo = { ...post.frontmatter };
  seo.title = `${ post.frontmatter.title } | Dhruv Kumar Jha`;
  if ( post.frontmatter.tags && post.frontmatter.tags.length > 0 ) {
    seo.keywords = post.frontmatter.tags.join(', ');
  }


  return (
    <div className="markdown--content">

      <SEO data={ seo } />

      <div dangerouslySetInnerHTML={{ __html: post.html }} />

    </div>
  )
}


export const postQuery = graphql`
    query ContentPagesByPath($path: String!) {
      markdownRemark(frontmatter: { path: { eq: $path} }) {
        html
        frontmatter {
          path
          title
          type
          description
          tags
          date(formatString: "MMMM DD, YYYY [at] hh:mm A")
        }
      }
    }
  `



// WEBPACK FOOTER //
// ./src/global/templates/page.js